import { render, staticRenderFns } from "./technicalProposal.vue?vue&type=template&id=83dcd356&scoped=true&"
import script from "./technicalProposal.vue?vue&type=script&lang=js&"
export * from "./technicalProposal.vue?vue&type=script&lang=js&"
import style0 from "./technicalProposal.vue?vue&type=style&index=0&id=83dcd356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dcd356",
  null
  
)

export default component.exports